module.exports = __webpack_public_path__ + "static/googleserp-4f766ff491fe751e36af3620c0c272cf.png";